import { render, staticRenderFns } from "./ReferredRegistrations.vue?vue&type=template&id=7fd2f5b4&scoped=true&"
import script from "./ReferredRegistrations.vue?vue&type=script&lang=js&"
export * from "./ReferredRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./ReferredRegistrations.vue?vue&type=style&index=0&id=7fd2f5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2f5b4",
  null
  
)

export default component.exports